import React, { useState } from 'react';
import { Text, withSitecoreContext, Link, mediaApi } from '@sitecore-jss/sitecore-jss-react';
import { RoutableLink } from "../../react/RoutableLink";
import { Sizes, Colors } from '../../ts/enums';
import css from './index.module.scss';
import '../../ts/polyfills';
import { LazyLoadComponent, trackWindowScroll } from 'react-lazy-load-image-component';

const PhotoTabs = (props) => {
  const { fields, sitecoreContext } = props;
  const validTiles = fields.children.filter(x => x.fields?.tileImage?.value?.src && !(isEditing || x.fields.tileImage.value.class == "scEmptyImage"));

  const [selectedTab, setSelectedTab] = useState(validTiles.length > 1 ? validTiles.find(x => x.fields.title.value) : validTiles[0] || null);

  const isEditing = sitecoreContext?.pageEditing;

  return (
    isEditing || fields?.title?.value && fields?.description?.value && validTiles?.length > 0 ?
      <section className={`${css.container} single-col-inner`} >
        <LazyLoadComponent threshold={100} >
        {
          <div className={css.imageContainer}
            // image tile side, defaults to left
            data-alignment={fields?.tileAlignment?.fields?.align?.value || "right"}
            style={{ backgroundImage: selectedTab?.fields?.tileImage?.value?.src ? `url(${mediaApi.updateImageUrl(selectedTab?.fields?.tileImage?.value?.src.split('?')[0])})` : '' }}>
            <div className={css.tabDescription}>
              <Text field={selectedTab?.fields?.description} tag='p' data-size={Sizes.SMALL} className={css.description} editable={false} />

              {selectedTab?.fields?.ctalink?.value?.href && selectedTab?.fields?.ctalinktext?.value ?
                <RoutableLink field={selectedTab.fields.ctalink} className={css.selectedCta} data-color={Colors.WHITE} data-chevron={true} editable={false} ariaLabel={selectedTab?.fields?.ARIALabelText?.value || ''}>
                  <Text field={selectedTab.fields.ctalinktext} editable={false} />
                </RoutableLink> : null
              }
            </div>
          </div>
        }
        <div className={css.tabContainer}
          data-alignment={fields?.backgroundImagePosition?.fields?.align?.value}
          style={{
            backgroundImage: fields?.backgroundImage?.value?.src ? `url(${mediaApi.updateImageUrl(fields?.backgroundImage?.value?.src.split('?')[0])})` : '',
            backgroundSize: fields?.height?.value ? fields?.height?.value + "px auto" : ''
          }}>

          {/* datasource item data  */}
          <Text field={fields?.title} tag='h3' className={css.title} />
          <Text field={fields?.description} tag='p' data-size={Sizes.SMALL} className={css.description} />
          {
            isEditing ?
              <div className={css.ctaLink}>
                <Link field={fields.ctalink} className={css.cta} data-chevron={true} />
                <Text field={fields.ctalinktext} />
              </div> : (fields?.ctalink?.value?.href && fields?.ctalinktext?.value) &&
              <div className={css.ctaLink}>
                <RoutableLink field={fields.ctalink} className={css.cta} data-chevron={true} ariaLabel={fields?.ARIALabelText?.value || ''}>
                  <Text field={fields.ctalinktext} />
                </RoutableLink>

              </div>
          }

          {/* photo tabs links activated by hover */}
          {
            validTiles &&
            <ul className={css.ctaLinkContainer}>
              {
                validTiles.map(x =>
                  <li key={x.id} className={css.tabLink} onMouseOver={() => setSelectedTab(x)} onFocus={() => setSelectedTab(x)}>
                    {
                      x.fields?.ctalink?.value?.href && x?.fields?.title?.value ?
                        <RoutableLink field={x.fields?.ctalink} className={css.tabCta} data-chevron={true} editable={false} ariaLabel={x.fields?.ARIALabelText?.value || ''}>
                          <Text field={x.fields.title} editable={false} />
                        </RoutableLink>
                        : <Text field={x.fields.title} editable={false} />
                    }
                  </li>
                )
              }
            </ul>
          }
        </div>
        {Object.keys(fields)?.length <= 1 && <p>Add and configure a Photo Tabs datasource item to see component data here.</p>}
        </LazyLoadComponent>
      </section >
      : null
  );
}

// export default withSitecoreContext()(trackWindowScroll(PhotoTabs));
export default withSitecoreContext()(PhotoTabs);